<template>
  <div class="mheader">
    <div class="headbox" v-if="hidden">
      <div v-if="status" class="mheader-inner trans">
        <img class="menu" @click="menu" src="../../assets/mimages/component/thinkgrow_homepage_ios_leftbar@3x.png" alt="" />
        <img class="logo" @click="goPath('/main')" src="../../assets/images/component/thinkgrow_homepage_logo01.png" alt="" />
      </div>
      <div v-else class="mheader-inner white">
        <img class="menu" @click="menu" src="../../assets/mimages/component/thinkgrow_homepage_ios_leftbar_b@2x.png" alt="" />
        <img class="logo" @click="goPath('/main')" src="../../assets/images/component/thinkgrow_homepage_logo02.png" alt="" />
      </div>
    </div>
    <!-- 抽屉弹窗菜单 -->
    <el-drawer :visible.sync="drawer" :append-to-body="true" :with-header="false" @close="close" direction="ltr" ref="drawer" size="100%">
      <div class="drawer">
        <div class="drawer-title">
          <img class="logo" style="width: 2.39rem" @click="goPath('/main')" src="../../assets/images/component/thinkgrow_homepage_logo02.png" alt="" />
          <span class="el-icon-close" @click="close"></span>
        </div>
        <div class="drawer-menu">
          <el-menu :default-active="activeName" class="el-menu-vertical-demo">
            <el-submenu index="0">
              <template slot="title">
                <span slot="title" @click="goPath('/samsung')">WHY THINKGROW</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="21" @click="goPath('/samsung')">WAY SAMSUNG</el-menu-item>
                <el-menu-item index="2" @click="goPath('/whythinkgrow')">480V MADE-TO-ORDER</el-menu-item>
                <el-menu-item index="3" @click="goPath('/controllability')">CONTROLLABILITY</el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <el-submenu index="1">
              <template slot="title">
                <span @click="goPathPosnNo('modelone')">MODEL ONE SYSTEM</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="11" @click="goPath('/modelone')">MODEL ONE SYSTEM</el-menu-item>
                <el-menu-item index="11" @click="goPath('/innercanopy')">INNER CANOPY LED</el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <el-submenu index="2">
              <template slot="title">
                <span @click="goPathPosnNo('houseled')">SINGLE-BAR LEDs</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="2" @click="goPath('/modeli')">MODEL-I</el-menu-item>
                <el-menu-item index="3" @click="goPath('/modeliplus')">MODEL-I PLUS</el-menu-item>
                <el-menu-item index="4" @click="goPathPosn('houseled')">COMPARISON</el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <el-submenu index="5">
              <template slot="title">
                <span @click="goPathPosnNo('indoor')">MULTIPLE-BAR LEDs</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="6" @click="goPath('/modelh')">MODEL-H</el-menu-item>
                <el-menu-item index="6" @click="goPath('/modelhplus')">MODEL-H Plus</el-menu-item>
                <!-- <el-menu-item index="6" @click="goPath('/newmodelh')">NEW MODEL-H</el-menu-item> -->
                <el-menu-item index="7" @click="goPath('/modelw')">MODEL-W</el-menu-item>
                <el-menu-item index="8" @click="goPath('/modelv')">MODEL-V</el-menu-item>
                <el-menu-item index="9" @click="goPathPosn('indoor')">COMPARISON</el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <el-submenu index="10">
              <template slot="title">
                <span slot="title" @click="goPath('/daisychain')">ACCESSORIES</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="13" @click="goPath('/daisychain')">Daisy Chain Power Cord</el-menu-item>
                <el-menu-item index="13" @click="goPath('/accessory')">Featured Accessories</el-menu-item>
                <el-menu-item index="13" @click="goPath('/smartlightlifter')">SMART LIFTER SYSTEM</el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <el-submenu index="11">
              <template slot="title">
                <span slot="title" @click="diashow()">SUPPORT</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="12" @click="goPath('/rebate')">LED Rebate</el-menu-item>
                <el-menu-item index="12" @click="goPath('/warranty')">WARRANTY(RMA)</el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <el-submenu index="12">
              <template slot="title">
                <span slot="title" @click="goTrolmasterWeb">TROLMASTER</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="121" @click="goTrolmasterWeb">TROLMASTER</el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <!-- <el-menu-item index="11">
<span slot="title" @click="diashow()">SUPPORT</span>
            </el-menu-item> -->
          </el-menu>
        </div>
      </div>
    </el-drawer>

    <el-dialog title="Contact Us" :modal-append-to-body="false" :visible.sync="contactUsshow" width="7rem">
      <el-form :model="formdata">
        <el-form-item label="Address :">315 E. Enterprise Drive, Pueblo West, CO 81007 </el-form-item>
        <el-form-item label="Tech Support :">877-420-9876 </el-form-item>
        <el-form-item label="Email :">Support@thinkgrow.com </el-form-item>
        <el-form-item label="Powered by TrolMaster "></el-form-item>
      </el-form>
      <el-form :model="formdata1" style="margin-top: 40px">
        <el-form-item><span style="font-size: 0.36rem;line-height: 0.24rem;color: #303133;">Orders and Shipping:</span></el-form-item>
        <el-form-item label="ThinkGrow Agricultural Technology, Inc."></el-form-item>
        <el-form-item label="Phone :">279-300-4980</el-form-item>
        <el-form-item label="Email :">sales@thinkgrow.com</el-form-item>
        <el-form-item label="7991 Folsom Blvd. Unit 2–3 Sacramento, CA 95826"></el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'mheaderder',
  data() {
    return {
      drawer: false,
      activeName: '1',
      show1: false,
      show2: false,
      show3: false,
      contactUsshow: false,
      formdata: {},
      formdata1: {},
      state: 0
    }
  },
  props: {
    hidden: {
      type: Boolean
    },
    status: {
      type: Boolean
    }
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    goTrolmasterWeb() {
      window.location = 'https://www.trolmaster.com/'
    },
    diashow() {
      let that = this
      that.drawer = false
      that.contactUsshow = true
    },
    menu() {
      this.drawer = true
      this.contactUsshow = false
      this.$emit('show')
    },
    close() {
      this.drawer = false
      // this.contactUsshow = false
      this.$emit('show')
    },
    goPath(path) {
      this.drawer = false
      this.contactUsshow = false
      this.$emit('show')
      if (path != this.$route.path) {
        this.$router.push({
          path: path
        })
      }
    },
    goPathPosnNo(path) {
      this.drawer = false
      this.contactUsshow = false
      this.$emit('show')
      this.state = 0
      this.$router.push({
        path: '/' + path,
        name: path,
        params: {
          state: this.state
        }
      })
    },
    goPathPosn(path) {
      this.drawer = false
      this.contactUsshow = false
      this.$emit('show')
      this.state = this.state + 1
      this.$router.push({
        path: '/' + path,
        name: path,
        params: {
          state: this.state
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.drawer {
  &-title {
    text-align: center;
    position: relative;
    border-bottom: 1px #f0f0f0 solid;
    height: 100%;

    .logo {
      display: inline-block;
      width: 0.4rem;
    }

    .el-icon-close {
      position: absolute;
      right: 0.1rem;
      top: 0.1rem;
      z-index: 10;
      color: #404040;
      font-size: 30px;
    }
  }

  &-menu {
    >>> .el-collapse-item__header {
      padding-left: 20px;
    }

    >>> .el-collapse-item__wrap {
      padding: 0 15px;
    }

    >>> .el-menu-item-group > ul {
      background-color: #f1f1f1;
    }

    >>> .el-submenu .el-menu-item {
      border-bottom: 1px #fff solid;
    }

    >>> .el-menu-item-group__title {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
}

.el-menu-item.is-active {
  color: #303133;
}

.mheader {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  width: 7.5rem;

  .white {
    background-color: #fff;
  }

  &-inner {
    padding: 0.2rem;
    position: relative;
    text-align: center;

    .menu {
      width: 0.57rem;
      position: absolute;
      left: 0.2rem;
      margin-top: -0.11rem;
      top: 50%;
      z-index: 999;
    }

    .logo {
      display: inline-block;
      width: 2.31rem;
      height: 0.7rem;
      // position: absolute;
      // left: 50%;
      // margin-left: -0.205rem;
      // top: 0;
      // z-index: 999;
    }
  }

  // 后期删除
  .el-dialog__wrapper {
    >>> .el-dialog__headerbtn {
      font-size: 0.32rem;
      color: #5f5f5f;

      .el-dialog__close:hover {
        color: #313131;
      }
    }

    >>> .el-form-item__content {
      line-height: 0.45rem;
      font-size: 0.2rem !important;
    }

    >>> .el-dialog__header {
      padding: 0.8rem 0.6rem 0;
    }

    >>> .el-dialog__body {
      padding: 0.4rem 0.6rem 0.6rem;
    }

    >>> .el-dialog__title {
      font-size: 0.36rem;
    }

    >>> .el-form-item {
      margin-bottom: 0;
      font-size: 0.2rem;
    }

    >>> .el-form-item__label {
      font-size: 0.2rem;
      line-height: 0.45rem;
    }

    .dialog-footer {
      padding-bottom: 0.4rem;
      text-align: right;

      .disbtn {
        margin-top: 0.25rem;
        display: inline-block;
        border: 0.02rem #313131 solid;
        color: #313131;
        border-radius: 0.03rem;
        font-size: 0.2rem;
        font-weight: 600;
        width: 1.6rem;
        height: 0.4rem;
        text-align: center;
        line-height: 0.4rem;
        cursor: pointer;

        &:hover {
          background-color: #313131;
          color: #fff;
        }
      }
    }

    .privacy {
      font-size: 0.16rem;
      line-height: 0.28rem;
      color: #313131;

      .title {
        font-size: 0.26rem;
        line-height: 0.32rem;
        font-weight: 600;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/mlayout/component/Headerbar.vue